<template>
  <Layout>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <div>
              <h4 class="mb-0">Configuração de Recebedor</h4>
              <p class="text-muted mb-0">
                {{ isEdit ? 'Atualize as informações do recebedor cadastrado.' : 'Configure as informações necessárias para cadastrar um recebedor.' }}
              </p>
            </div>
            <div class="d-flex align-items-center">
              <span v-if="isEdit" class="badge badge-info badge-pill px-3 py-2 mr-2">
                <i class="mdi mdi-pencil mr-1"></i> Modo Edição
              </span>
              <span v-if="recipient && recipient.status === 'active'" class="badge badge-success badge-pill px-3 py-2">
                <i class="mdi mdi-check-circle mr-1"></i> Conta Ativa
              </span>
              <span v-else-if="recipient && recipient.status === 'pending'" class="badge badge-warning badge-pill px-3 py-2">
                <i class="mdi mdi-clock mr-1"></i> Pendente
              </span>
            </div>
          </div>
        </div>
      </div>

      <loading
        :active.sync="loading"
        color="#556ee6"
        loader="dots"
        :can-cancel="false"
        :is-full-page="false">
      </loading>

      <form @submit.prevent="save">
        <!-- Identificação -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-4">
                  <i class="bx bx-id-card text-primary font-size-20 align-middle mr-2"></i>
                  Identificação
                </h5>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Razão Social <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        placeholder="Digite a razão social da empresa"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Nome Fantasia</label>
                      <input
                        type="text"
                        v-model="form.trading_name"
                        class="form-control"
                        placeholder="Digite o nome fantasia (opcional)"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>CNPJ <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.document"
                        v-mask="'##.###.###/####-##'"
                        class="form-control"
                        placeholder="00.000.000/0000-00"
                        :disabled="isEdit"
                        @blur="copyDocumentToHolder"
                        required
                      >
                      <small class="text-muted">
                        <i class="mdi mdi-shield-check"></i> Deve ser um CNPJ válido com dígitos verificadores corretos
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>E-mail <span class="text-danger">*</span></label>
                      <input
                        type="email"
                        v-model="form.email"
                        class="form-control"
                        placeholder="contato@empresa.com"
                        required
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Faturamento Anual <span class="text-danger">*</span></label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">R$</span>
                        </div>
                        <input
                          type="text"
                          v-model="form.annual_revenue"
                          class="form-control"
                          placeholder="0,00"
                          required
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Telefone (Preferencialmente celular) <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.phone"
                        v-mask="'(##) #####-####'"
                        class="form-control"
                        placeholder="(11) 99999-9999"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Data de Fundação <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.founding_date"
                        v-mask="'##/##/####'"
                        class="form-control"
                        placeholder="DD/MM/AAAA"
                        required
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Tipo Societário <span class="text-danger">*</span></label>
                      <select v-model="form.corporation_type" class="form-control" required>
                        <option value="">Selecione</option>
                        <option value="ltda">LTDA</option>
                        <option value="individual_entrepreneur">MEI / Empresário Individual</option>
                        <option value="eireli">EIRELI</option>
                        <option value="sa">S/A</option>
                        <option value="association">Associação</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Endereço Completo -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-4">
                  <i class="bx bx-map text-success font-size-20 align-middle mr-2"></i>
                  Endereço Completo
                </h5>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>CEP <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.zip_code"
                        v-mask="'#####-###'"
                        class="form-control"
                        placeholder="00000-000"
                        @blur="searchCep"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Logradouro <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.street"
                        class="form-control"
                        placeholder="Rua, Avenida, Alameda..."
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="form-group">
                      <label>Número <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.street_number"
                        class="form-control"
                        placeholder="123"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label>Complemento</label>
                      <input
                        type="text"
                        v-model="form.complementary"
                        class="form-control"
                        placeholder="Apto, Sala, Bloco..."
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Bairro <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.neighborhood"
                        class="form-control"
                        placeholder="Nome do bairro"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Cidade <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.city"
                        class="form-control"
                        placeholder="Nome da cidade"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Estado (UF) <span class="text-danger">*</span></label>
                      <select v-model="form.state" class="form-control" required>
                        <option value="">Selecione</option>
                        <option value="AC">Acre</option>
                        <option value="AL">Alagoas</option>
                        <option value="AP">Amapá</option>
                        <option value="AM">Amazonas</option>
                        <option value="BA">Bahia</option>
                        <option value="CE">Ceará</option>
                        <option value="DF">Distrito Federal</option>
                        <option value="ES">Espírito Santo</option>
                        <option value="GO">Goiás</option>
                        <option value="MA">Maranhão</option>
                        <option value="MT">Mato Grosso</option>
                        <option value="MS">Mato Grosso do Sul</option>
                        <option value="MG">Minas Gerais</option>
                        <option value="PA">Pará</option>
                        <option value="PB">Paraíba</option>
                        <option value="PR">Paraná</option>
                        <option value="PE">Pernambuco</option>
                        <option value="PI">Piauí</option>
                        <option value="RJ">Rio de Janeiro</option>
                        <option value="RN">Rio Grande do Norte</option>
                        <option value="RS">Rio Grande do Sul</option>
                        <option value="RO">Rondônia</option>
                        <option value="RR">Roraima</option>
                        <option value="SC">Santa Catarina</option>
                        <option value="SP">São Paulo</option>
                        <option value="SE">Sergipe</option>
                        <option value="TO">Tocantins</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sócios Administradores (KYC PJ) -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-user-circle text-warning font-size-20 align-middle mr-2"></i>
                    Sócios Administradores
                  </h5>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="addPartner">
                    <i class="mdi mdi-plus mr-1"></i> Adicionar sócio
                  </button>
                </div>

                <div class="alert alert-warning">
                  <i class="mdi mdi-alert mr-2"></i>
                  <strong>Obrigatório para validação KYC:</strong> inclua todos os sócios com participação relevante (≥25%).
                  Marque ao menos um como representante legal autodeclarado.
                </div>

                <div v-if="form.managing_partners.length === 0" class="text-muted text-center py-3">
                  Nenhum sócio cadastrado. Clique em "Adicionar sócio" para começar.
                </div>

                <div v-for="(partner, idx) in form.managing_partners" :key="idx" class="border rounded p-3 mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0">Sócio #{{ idx + 1 }}</h6>
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="removePartner(idx)">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Nome completo <span class="text-danger">*</span></label>
                        <input type="text" v-model="partner.name" class="form-control" required>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Nome da mãe</label>
                        <input type="text" v-model="partner.mother_name" class="form-control">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>CPF <span class="text-danger">*</span></label>
                        <input type="text" v-model="partner.document"
                               v-mask="'###.###.###-##'"
                               class="form-control" placeholder="000.000.000-00" required>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Data de nascimento</label>
                        <input type="text" v-model="partner.birthdate"
                               v-mask="'##/##/####'"
                               class="form-control" placeholder="DD/MM/AAAA">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>E-mail <span class="text-danger">*</span></label>
                        <input type="email" v-model="partner.email" class="form-control" required>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Renda mensal</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">R$</span>
                          </div>
                          <input type="text" v-model="partner.monthly_income" class="form-control" placeholder="0,00">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Profissão</label>
                        <input type="text" v-model="partner.professional_occupation" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Telefone</label>
                        <input type="text" v-model="partner.phone"
                               v-mask="'(##) #####-####'"
                               class="form-control" placeholder="(11) 99999-9999">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>CEP</label>
                        <input type="text" v-model="partner.zip_code"
                               v-mask="'#####-###'"
                               class="form-control" placeholder="00000-000"
                               @blur="searchPartnerCep(idx)">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Logradouro</label>
                        <input type="text" v-model="partner.street" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-1">
                      <div class="form-group">
                        <label>Nº</label>
                        <input type="text" v-model="partner.street_number" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Compl.</label>
                        <input type="text" v-model="partner.complementary" class="form-control">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Bairro</label>
                        <input type="text" v-model="partner.neighborhood" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Cidade</label>
                        <input type="text" v-model="partner.city" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>UF</label>
                        <input type="text" v-model="partner.state" class="form-control" maxlength="2">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox"
                               class="custom-control-input"
                               :id="`partner-rep-${idx}`"
                               v-model="partner.self_declared_legal_representative">
                        <label class="custom-control-label" :for="`partner-rep-${idx}`">
                          Representante legal autodeclarado
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Informações da Conta Bancária -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-4">
                  <i class="bx bx-building text-purple font-size-20 align-middle mr-2" style="color: #6f42c1;"></i>
                  Informações da Conta Bancária
                </h5>

                <div class="alert alert-info">
                  <i class="mdi mdi-information mr-2"></i>
                  <strong>Atenção:</strong> Preencha os campos separadamente. O dígito da agência é opcional (nem todos os bancos usam).
                  O dígito da conta é obrigatório.
                  <br>
                  <small class="mt-2 d-block">
                    <strong>Exemplo:</strong> Se sua conta é <code>Ag: 1234-5 / Conta: 67890-1</code>, preencha:
                    <br>
                    Agência: <code>1234</code> | Dígito: <code>5</code> | Conta: <code>67890</code> | Dígito: <code>1</code>
                  </small>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Banco (Código/ISPB) <span class="text-danger">*</span></label>
                      <select v-model="form.bank_code" class="form-control" required>
                        <option value="">Selecione o banco</option>
                        <option value="001">001 - Banco do Brasil</option>
                        <option value="033">033 - Santander</option>
                        <option value="104">104 - Caixa Econômica Federal</option>
                        <option value="237">237 - Bradesco</option>
                        <option value="341">341 - Itaú Unibanco</option>
                        <option value="077">077 - Banco Inter</option>
                        <option value="260">260 - Nu Pagamentos (Nubank)</option>
                        <option value="290">290 - PagSeguro</option>
                        <option value="323">323 - Mercado Pago</option>
                        <option value="336">336 - C6 Bank</option>
                        <option value="422">422 - Banco Safra</option>
                        <option value="633">633 - Banco Rendimento</option>
                        <option value="655">655 - Banco Votorantim</option>
                        <option value="748">748 - Sicredi</option>
                        <option value="756">756 - Sicoob</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label>Agência <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.branch_number"
                        class="form-control"
                        placeholder="0001"
                        maxlength="10"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="form-group">
                      <label>Dígito</label>
                      <input
                        type="text"
                        v-model="form.branch_check_digit"
                        class="form-control"
                        placeholder="X"
                        maxlength="2"
                      >
                      <small class="text-muted">Opcional</small>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Número da Conta <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.account_number"
                        class="form-control"
                        placeholder="12345"
                        maxlength="20"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="form-group">
                      <label>Dígito <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.account_check_digit"
                        class="form-control"
                        placeholder="X"
                        maxlength="2"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label>Tipo de Conta Bancária <span class="text-danger">*</span></label>
                      <select v-model="form.account_type" class="form-control" required>
                        <option value="checking">Conta Corrente</option>
                        <option value="savings">Conta Poupança</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>CNPJ da Conta Bancária <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.holder_document"
                        v-mask="'##.###.###/####-##'"
                        class="form-control"
                        placeholder="00.000.000/0000-00"
                        required
                      >
                      <small class="form-text text-muted">
                        <i class="mdi mdi-information-outline"></i> Deve ser o mesmo CNPJ informado na seção de identificação
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Nome da Conta Bancária <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="form.holder_name"
                        class="form-control"
                        placeholder="Nome conforme registro bancário"
                        required
                      >
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-12 text-right">
                    <button type="submit" class="btn btn-primary px-5 py-2" :disabled="loading">
                      <i :class="isEdit ? 'mdi mdi-refresh mr-2' : 'mdi mdi-content-save mr-2'"></i>
                      {{ isEdit ? 'Atualizar Recebedor' : 'Cadastrar Recebedor' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getRecipientByEvent, createRecipient, updateRecipient } from './services'

export default {
  components: {
    Layout,
    Loading
  },
  data () {
    return {
      loading: false,
      recipient: null,
      isEdit: false,
      form: {
        name: '',
        trading_name: '',
        document: '',
        email: '',
        annual_revenue: '',
        phone: '',
        corporation_type: '',
        founding_date: '',
        zip_code: '',
        street: '',
        street_number: '',
        complementary: '',
        neighborhood: '',
        city: '',
        state: '',
        bank_code: '',
        branch_number: '',
        branch_check_digit: '',
        account_number: '',
        account_check_digit: '',
        account_type: 'checking',
        holder_document: '',
        holder_name: '',
        recipient_type: 'company',
        managing_partners: []
      }
    }
  },
  mounted () {
    this.loadRecipient()
  },
  methods: {
    async loadRecipient () {
      this.loading = true
      try {
        const response = await getRecipientByEvent(1) // Sistema single-tenant
        if (response.data && response.data.id) {
          this.recipient = response.data
          this.isEdit = true

          // Formatar documentos com máscara
          const formatDocument = (doc) => {
            const cleaned = doc.replace(/\D/g, '')
            if (cleaned.length === 14) {
              // CNPJ: 00.000.000/0000-00
              return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            } else if (cleaned.length === 11) {
              // CPF: 000.000.000-00
              return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            }
            return doc
          }

          // Preencher dados básicos
          this.form = {
            ...this.form,
            name: response.data.name,
            email: response.data.email,
            document: formatDocument(response.data.document),
            recipient_type: response.data.type,
            bank_code: response.data.bank_code,
            branch_number: response.data.branch_number,
            branch_check_digit: response.data.branch_check_digit || '',
            account_number: response.data.account_number,
            account_check_digit: response.data.account_check_digit || '',
            account_type: response.data.account_type,
            holder_name: response.data.holder_name,
            holder_document: formatDocument(response.data.holder_document)
          }

          // Preencher dados de register_information (nome fantasia, telefone, endereço)
          if (response.data.register_information) {
            const info = response.data.register_information
            this.form.trading_name = info.trading_name || ''
            this.form.annual_revenue = info.annual_revenue || ''
            this.form.corporation_type = info.corporation_type || ''
            this.form.founding_date = info.founding_date || ''
            this.form.managing_partners = Array.isArray(info.managing_partners)
              ? info.managing_partners.map(p => ({
                name: p.name || '',
                email: p.email || '',
                document: p.document || '',
                mother_name: p.mother_name || '',
                birthdate: p.birthdate || '',
                monthly_income: p.monthly_income || '',
                professional_occupation: p.professional_occupation || '',
                phone: p.phone || '',
                zip_code: p.zip_code || '',
                street: p.street || '',
                street_number: p.street_number || '',
                complementary: p.complementary || '',
                neighborhood: p.neighborhood || '',
                city: p.city || '',
                state: p.state || '',
                self_declared_legal_representative: !!p.self_declared_legal_representative
              }))
              : []

            // Formatar telefone para exibição (adicionar máscara)
            if (info.phone) {
              const phone = info.phone.replace(/\D/g, '')
              if (phone.length === 11) {
                this.form.phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
              } else if (phone.length === 10) {
                this.form.phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
              } else {
                this.form.phone = info.phone
              }
            }

            if (info.address) {
              // Formatar CEP para exibição
              const zipCode = info.address.zip_code.replace(/\D/g, '')
              if (zipCode.length === 8) {
                this.form.zip_code = zipCode.replace(/(\d{5})(\d{3})/, '$1-$2')
              } else {
                this.form.zip_code = info.address.zip_code || ''
              }

              this.form.street = info.address.street || ''
              this.form.street_number = info.address.street_number || ''
              this.form.complementary = info.address.complementary || ''
              this.form.neighborhood = info.address.neighborhood || ''
              this.form.city = info.address.city || ''
              this.form.state = info.address.state || ''
            }
          }
        }
      } catch (error) {
        if (error.response && error.response.status !== 404) {
          this.$toast.error('Erro ao carregar dados do recebedor')
          console.error(error)
        }
      } finally {
        this.loading = false
      }
    },
    async save () {
      this.loading = true
      try {
        if (this.isEdit) {
          await updateRecipient(this.recipient.id, this.form)
          this.$toast.success('Recebedor atualizado com sucesso!')
        } else {
          const response = await createRecipient(this.form)
          this.$toast.success('Recebedor cadastrado com sucesso!')
          this.recipient = response.data
          this.isEdit = true
        }
        await this.loadRecipient()
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.response?.data?.error || 'Erro ao salvar recebedor'
        this.$toast.error(errorMsg)
        console.error('Erro ao salvar:', error.response?.data || error)
      } finally {
        this.loading = false
      }
    },
    async searchCep () {
      if (this.form.zip_code && this.form.zip_code.replace(/\D/g, '').length === 8) {
        try {
          const cep = this.form.zip_code.replace(/\D/g, '')
          const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
          const data = await response.json()

          if (!data.erro) {
            this.form.street = data.logradouro
            this.form.neighborhood = data.bairro
            this.form.city = data.localidade
            this.form.state = data.uf
          }
        } catch (error) {
          console.error('Erro ao buscar CEP:', error)
        }
      }
    },
    addPartner () {
      this.form.managing_partners.push({
        name: '',
        email: '',
        document: '',
        mother_name: '',
        birthdate: '',
        monthly_income: '',
        professional_occupation: '',
        phone: '',
        zip_code: '',
        street: '',
        street_number: '',
        complementary: '',
        neighborhood: '',
        city: '',
        state: '',
        self_declared_legal_representative: this.form.managing_partners.length === 0
      })
    },
    removePartner (idx) {
      this.form.managing_partners.splice(idx, 1)
    },
    async searchPartnerCep (idx) {
      const partner = this.form.managing_partners[idx]
      if (!partner || !partner.zip_code) return
      const cep = partner.zip_code.replace(/\D/g, '')
      if (cep.length !== 8) return
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        const data = await response.json()
        if (!data.erro) {
          partner.street = data.logradouro
          partner.neighborhood = data.bairro
          partner.city = data.localidade
          partner.state = data.uf
        }
      } catch (error) {
        console.error('Erro ao buscar CEP do sócio:', error)
      }
    },
    copyDocumentToHolder () {
      // Auto-preencher CNPJ da conta bancária com o CNPJ principal
      if (this.form.document && !this.form.holder_document) {
        this.form.holder_document = this.form.document
        this.$toast.info('CNPJ copiado para conta bancária')
      }
    }
  }
}
</script>

<style scoped>
.text-purple {
  color: #6f42c1 !important;
}
</style>
